import React, { useState, useEffect, useRef } from 'react';
import { Input, Popover, List, Typography, Tag, Spin, Space } from 'antd';
import { SearchOutlined, ProjectOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';

const { Text } = Typography;

export default function GlobalSearch() {
  const [query, setQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, 500);
    return () => clearTimeout(handler);
  }, [query]);

  useEffect(() => {
    if (debouncedQuery.length >= 2) {
      setLoading(true);
      api.get(`/search?query=${encodeURIComponent(debouncedQuery)}`)
        .then(res => {
          setResults(res.data);
          setLoading(false);
          setOpen(true);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setResults(null);
      setOpen(false);
    }
  }, [debouncedQuery]);

  const handleTaskClick = (taskId) => {
    setOpen(false);
    navigate(`/tasks?taskId=${taskId}`);
  };

  const handleProjectClick = (projectId) => {
    setOpen(false);
    navigate(`/projects?projectId=${projectId}`);
  };

  const handleFileClick = (file) => {
    setOpen(false);
    if (file.task_id) {
      navigate(`/tasks?taskId=${file.task_id}`);
    } else if (file.project_id) {
      navigate(`/projects?projectId=${file.project_id}`);
    } else {
      // «Файлы» больше не экран СУПа — открываем файл в Nextcloud
      window.open(`/api/v1/files/${file.id}/nc-url`, '_blank');
    }
  };

  const content = (
    <div style={{ width: 350, maxHeight: 400, overflowY: 'auto' }}>
      {loading ? (
        <div style={{ textAlign: 'center', padding: 20 }}><Spin /></div>
      ) : results ? (
        <>
          {results.projects?.count > 0 && (
            <div style={{ marginBottom: 16 }}>
              <Text strong style={{ color: '#1890ff' }}>Проекты ({results.projects.count})</Text>
              <List
                size="small"
                dataSource={results.projects.items}
                renderItem={item => (
                  <List.Item style={{ cursor: 'pointer' }} onClick={() => handleProjectClick(item.id)}>
                    <List.Item.Meta
                      avatar={<ProjectOutlined />}
                      title={item.title}
                      description={item.match_type === 'comment' ? <Text type="secondary" ellipsis>{item.match_text}</Text> : null}
                    />
                  </List.Item>
                )}
              />
            </div>
          )}
          {results.tasks?.count > 0 && (
            <div style={{ marginBottom: 16 }}>
              <Text strong style={{ color: '#52c41a' }}>Задачи ({results.tasks.count})</Text>
              <List
                size="small"
                dataSource={results.tasks.items}
                renderItem={item => (
                  <List.Item style={{ cursor: 'pointer' }} onClick={() => handleTaskClick(item.id)}>
                    <List.Item.Meta
                      avatar={<ProjectOutlined />}
                      title={item.title}
                      description={item.match_type === 'comment' ? <Text type="secondary" ellipsis>{item.match_text}</Text> : null}
                    />
                  </List.Item>
                )}
              />
            </div>
          )}
          {results.files?.count > 0 && (
            <div>
              <Text strong style={{ color: '#faad14' }}>Файлы ({results.files.count})</Text>
              <List
                size="small"
                dataSource={results.files.items}
                renderItem={item => (
                  <List.Item style={{ cursor: 'pointer' }} onClick={() => handleFileClick(item)}>
                    <List.Item.Meta
                      avatar={<FileTextOutlined />}
                      title={item.name}
                    />
                  </List.Item>
                )}
              />
            </div>
          )}
          {results.projects?.count === 0 && results.tasks?.count === 0 && results.files?.count === 0 && (
            <Text type="secondary">Ничего не найдено</Text>
          )}
        </>
      ) : (
        <Text type="secondary">Введите минимум 2 символа для поиска</Text>
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      title="Результаты поиска"
      trigger="click"
      open={open}
      onOpenChange={(newOpen) => setOpen(newOpen && debouncedQuery.length >= 2)}
      placement="bottom"
    >
      <Input
        placeholder="Поиск..."
        prefix={<SearchOutlined />}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        allowClear
        style={{ width: 250 }}
      />
    </Popover>
  );
}
